export default __webpack_public_path__ + "static/media/home-icon.c158ace1.webp";